var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf-page',{attrs:{"bg":"cover"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.name))]),_c('div',[_vm._v("小朋友教学进展季报")])]),_c('div',{staticStyle:{"margin-top":"18px"}},[_vm._v(" （"+_vm._s(_vm._f("moment")(_vm.start,'YYYY年MM月DD日'))+"—"+_vm._s(_vm._f("moment")(_vm.end,'YYYY年MM月DD日'))+"） ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }